import qs from 'qs';

export const getCurrentTabFromSearchParam = (searchParam: string): string => {
  const searchString = searchParam.slice(1);
  const { tab } = qs.parse(searchString);

  return tab ? String(tab) : '';
};
